import { ACTION_TYPES } from "../actions/comment";
import { initialState } from "./initialState";

export const comment = (state = initialState.comment, action) => {
    switch (action.type) {
        case ACTION_TYPES.FETCH_ALL_COMMENTS:
            return {
                ...state,
                list: [...action.payload.item1],
                total: action.payload.item2
            };
        case ACTION_TYPES.CREATE_COMMENT:
            return {
                ...state,
                list: [action.payload, ...state.list]
            };
        case ACTION_TYPES.UPDATE_COMMENT:
            return {
                ...state,
                list: state.list.map(x => x.id === action.payload.id ? action.payload : x)
            };
        case ACTION_TYPES.DELETE_COMMENT:
            return {
                ...state,
                list: state.list.filter(x => x.id !== action.payload)
            };
        default:
            return state;
    }
}